import React, { FC } from "react";
import dummyImage from "assets/images/common/others/minorImage.png";

interface Props {
  user: any;
}

const PersonalInformation: FC<Props> = ({ user }) => {
  return (
    <div className="">
      <div className="my-8 grid grid-cols-5 gap-8">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            First Name
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.firstName || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Last Name
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.lastName || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Date of Birth
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.dob || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Email</span>
          <span className="text-xs break-words text-tertiaryText">
            {user?.user?.email || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">Gender</span>
          <span className="text-xs text-tertiaryText">{user?.user?.gender || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Phone Number
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.phone || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Physical Address
          </span>
          <span className="text-xs text-tertiaryText">
           {user?.user?.address || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Languages
          </span>
          <div className="flex gap-2">
            <span className="text-xs bg-gray-200 px-2 py-1 rounded">
              {user?.user?.language || "-"}
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">City</span>
          <span className="text-xs text-tertiaryText">{user?.user?.city || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">State</span>
          <span className="text-xs text-tertiaryText">{user?.user?.state || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Zip Code
          </span>
          <span className="text-xs text-tertiaryText">{user?.user?.zipCode || "-"}</span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Member Since
          </span>
          <span className="text-xs text-tertiaryText"> {user?.user?.createdAt
              ? new Intl.DateTimeFormat("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }).format(new Date(user?.user?.createdAt))
              : "-"}</span>
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;
